<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item><router-link to="/">首页</router-link></el-breadcrumb-item>
      <el-breadcrumb-item>资料管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form inline label-width="60px" size="small" class="query-form" @submit.native.prevent="selClick">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-cascader :options="cateTree" v-model="cateQuery" clearable
            :props="{ value: 'id', label: 'label', checkStrictly: true }" @change="selClick"
            style="width:200px"></el-cascader>
          <!-- <router-link to="/sys_BasicData" target="_blank" style="margin-left:10px">
            <el-button type="text">分类管理</el-button>
          </router-link> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" @click="addClick">新增</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header"><span>资料列表</span></div>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="parentCategoryName" label="一级分类"></el-table-column>
          <el-table-column prop="categoryName" label="二级分类"></el-table-column>
          <el-table-column label="封面">
            <template slot-scope="scope">
              <img v-if="scope.row.coverImg" :src="domain + scope.row.coverImg" style="height:40px" />
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="fileUrl"
            label="PDF文件"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column prop="accessLevel" label="权限">
            <template slot-scope="scope">{{
              accessName(scope.row.accessLevel)
            }}</template>
          </el-table-column>
          <el-table-column prop="downCount" label="下载"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column label="启用">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isEnable" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
              <el-button type="text" style="color:#f56c6c" @click="delClick(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total,prev,sizes,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog :title="form.id > 0 ? '编辑资料' : '添加资料'" :visible.sync="dialogVisible" width="700px" @opened="
      dialogOpened();
    dialogOpened2();
    ">
      <el-form :model="form" ref="form" label-width="100px" @submit.native.prevent="submitForm">
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '请输入标题' }]">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-cascader :options="cateTree" v-model="cateList" clearable :props="{ value: 'id', label: 'label' }"
            style="width:100%"></el-cascader>
        </el-form-item>
        <el-form-item label="封面">
          <div id="uploadCoverMat" class="uploader uploader-warning"></div>
          <img v-if="form.coverImg" :src="domain + form.coverImg" style="height:40px;margin-left:10px" />
          <div class="uploader-text">支持 jpg/png，尺寸固定 450×600（3:4 竖版）</div>
        </el-form-item>
        <el-form-item label="PDF文件" prop="fileUrl" :rules="[{ required: true, message: '请上传PDF' }]">
          <div id="uploadPdf" class="uploader uploader-warning"></div>
          <span style="margin-left:12px">{{ form.fileUrl }}</span>
          <div class="uploader-text">仅支持 pdf，建议不超过 50MB</div>
        </el-form-item>
        <!-- <el-form-item label="预览PDF">
          <div id="uploadPreview" class="uploader uploader-warning"></div>
          <span style="margin-left:12px">{{ form.previewUrl }}</span>
        </el-form-item> -->
        <el-form-item label="简介"><el-input v-model="form.summary" type="textarea" :rows="2"></el-input></el-form-item>
        <el-form-item label="访问权限">
          <el-select v-model="form.accessLevel" style="width:100%">
            <el-option v-for="item in accessList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="8"><el-form-item label="允许下载"><el-switch
                v-model="form.allowDownload"></el-switch></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="排序"><el-input
                v-model.number="form.sort"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="启用"><el-switch
                v-model="form.isEnable"></el-switch></el-form-item></el-col>
        </el-row>

        <el-form-item label="资料展示图">
          <el-alert type="warning" :closable="true">
            <b>可不上传：保存时若无展示图，将自动把 PDF 转为图片作为展示图。</b>
          </el-alert>
          <br />
          <div id="minImageBtnConfig" class="uploader uploader-warning"></div>
          <div class="uploader-text">支持 jpg/png；不上传则保存时由 PDF 自动生成</div>
          <el-collapse v-if="imgList.length" v-model="imgCollapse" style="margin-top:10px">
            <el-collapse-item name="imgs">
              <template slot="title">
                已有展示图 {{ imgList.length }} 张（点击展开/收起）
              </template>
              <div class="img-list-wrap">
                <el-row>
                  <el-col v-for="(item, index) in imgList" :key="index" style="padding: 5px" :span="6">
                    <el-card :body-style="{ padding: '0px' }">
                      <el-image class="upload-demo" :src="domain + item.imgSmall" fit="contain"
                        style="width: 100%; height: 150px" :preview-src-list="[domain + item.imgBig]">
                      </el-image>
                      <div style="margin-left: 9px;margin-bottom: 20px;">
                        <el-button-group>
                          <el-tooltip content="前移" placement="top">
                            <el-button size="small" @click="moveclick(index)" type="primary" icon="arrow-left">前移</el-button>
                          </el-tooltip>
                          <el-tooltip content="删除" placement="top">
                            <el-button size="small" @click="deleteclick(index)" type="danger" icon="delete">删除</el-button>
                          </el-tooltip>
                        </el-button-group>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      key: "",
      cateQuery: [],
      cateList: [],
      cateTree: [],
      accessList: [],
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      submiting: false,
      form: {},
      imgList: [],
      imgCollapse: [],
    };
  },
  created() {
    this.loadCate();
    this.loadAccess();
    this.getList();
  },
  methods: {
    api(a) {
      return url.getMiniManage(a);
    },
    accessName(v) {
      if (v === 0) return "—";
      const item = this.accessList.find((x) => x.id === v);
      return item ? item.name : v;
    },
    loadCate() {
      $.get(url.getSys_BasicData("GetBaseTree"), { modelid: 14 }, (res) => {
        this.cateTree = res;
      });
    },
    loadAccess() {
      $.get(this.api("GetSelList_AccessLevel"), {}, (res) => {
        this.accessList = (res || []).filter(
          (x) => x.id !== 0 && x.name !== "仅展示标题"
        );
      });
    },
    getCateId(arr) {
      if (!arr || arr.length === 0) return undefined;
      return arr[arr.length - 1];
    },
    /** 根据叶子/任意节点 id，在分类树中找出 cascader 回显路径 */
    findCatePath(tree, id) {
      if (id == null || id === "" || !tree || !tree.length) return [];
      const walk = (nodes, path) => {
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          const next = path.concat(node.id);
          if (node.id == id) return next;
          if (node.children && node.children.length) {
            const found = walk(node.children, next);
            if (found) return found;
          }
        }
        return null;
      };
      return walk(tree, []) || [];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    selClick() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      $.get(
        this.api("GetList_Material"),
        {
          key: this.key,
          categoryId: this.getCateId(this.cateQuery),
          pageindex: this.currentPage,
          pagesize: this.pageSize,
        },
        (data) => {
          this.loading = false;
          this.tableData = data.list;
          this.total = data.total;
        },
      );
    },
    addClick() {
      this.form = {
        isEnable: true,
        allowDownload: false,
        accessLevel: 1,
        sort: 0,
      };
      this.cateList = [];
      this.imgList = [];
      this.dialogVisible = true;

    },
    editClick(row) {
      this.form = Object.assign({}, row);
      this.cateList = this.findCatePath(this.cateTree, row.categoryID);
      $.get(this.api("GetModel_Material"), { id: row.id }, (data) => {
        if (!data) {
          this.$message.error("获取详情失败：数据不存在");
          return;
        }
        this.form = { ...data };
        this.cateList = this.findCatePath(this.cateTree, data.categoryID);
        this.imgList = data.imgList ? JSON.parse(data.imgList) : [];
      }).fail(() => {
        this.$message.error("获取详情失败");
      });
      this.dialogVisible = true;
    },
    delClick(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" })
        .then(() => {
          $.post(this.api("Delete_Material"), { id: row.id }, (res) => {
            if (res.status) {
              this.getList();
              this.$message.success(res.msg);
            } else this.$message.error(res.msg);
          });
        })
        .catch(() => { });
    },
    bindUploader(sel, field, exts, maxMb, sizeField) {
      var _this = this;
      if ($(sel).length === 0) return;
      if ($(sel + " input").length > 0) return;
      $(sel).uploader({
        url: url.getUpload(),
        text: "上传",
        fileExts: exts,
        handleType: "0",
        maxSize: 1024 * 1024 * maxMb,
        onSuccess(data) {
          _this.$set(_this.form, field, data.relativeName);
          if (sizeField && data.size)
            _this.$set(_this.form, sizeField, data.size);
        },
      });
    },
    dialogOpened() {
      var _this = this;
      if ($("#uploadCoverMat").length && $("#uploadCoverMat input").length === 0) {
        $("#uploadCoverMat").uploader({
          url: url.getUpload(),
          text: "上传",
          fileExts: "jpg;png;jpeg",
          type: "fixedcut",
          handleType: "0",
          maxSize: 1024 * 1024 * 5,
          maxWidth: 450,
          maxHeight: 600,
          onSuccess(data) {
            _this.$set(_this.form, "coverImg", data.relativeName);
          },
        });
      }
      this.bindUploader("#uploadPdf", "fileUrl", "pdf", 50, "fileSize");
    },
    dialogOpened2() {
      var _this = this;
      if ($("#minImageBtnConfig input").length <= 0) {
        $("#minImageBtnConfig").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png;jpeg",
          text: "选择图片",
          more: true,
          auto: true,
          type: "imgdouble",
          minWidth: 800,
          minHeight: 800,
          maxWidth: 2000,
          maxHeight: 2000,
          handleType: "0",
          subfolder: "content",
          onSuccess: function (data) {
            var obj = {
              imgSmall: data.small.relativeName,
              imgBig: data.big.relativeName,
            };
            _this.imgList.push(obj);
          },
        });
      }
    },
    moveclick(index) {
      const list = this.imgList.slice();
      if (index === 0) {
        const last = list.length - 1;
        const tmp = list[0];
        list[0] = list[last];
        list[last] = tmp;
      } else {
        const tmp = list[index];
        list[index] = list[index - 1];
        list[index - 1] = tmp;
      }
      this.imgList = list;
    },
    deleteclick(index) {
      this.imgList.splice(index, 1);
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const info = Object.assign({}, this.form);
        info.categoryID = this.getCateId(this.cateList);
        info.imgList = JSON.stringify(this.imgList);
        this.submiting = true;
        $.post(this.api("Save_Material"), info, (res) => {
          this.submiting = false;
          if (res.status) {
            this.dialogVisible = false;
            // console.log('提交数据:', info);
            this.getList();
            this.$message.success(res.msg);
          } else this.$message.error(res.msg);
        });
      });
    },
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}

.uploader-text {
  color: #999;
  font-size: 12px;
  margin-top: 6px;
}
.img-list-wrap {
  max-height: 360px;
  overflow-y: auto;
}
</style>
